import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Support</Typography>
      <p>The table shows a list of suport request that you have made. If you have applied
        for our monthly contract then that will also appear here.
      </p>

      <p>Click any thread to view the conversation.</p>
    </div>
  )
}

export default HelpText